import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiOnboardingActiveService } from '@fi-app/fi-onboarding/fi-onboarding-active/fi-onboarding-active.service';
import { FiOnboardingActiveItemComponent } from '@fi-app/fi-onboarding/fi-onboarding-active/fi-onboarding-active-item/fi-onboarding-active-item.component';
import { FiOnboardingActiveListComponent } from '@fi-app/fi-onboarding/fi-onboarding-active/fi-onboarding-active-list/fi-onboarding-active-list.component';
import { FiLocalSearch2Module } from '@fi-app/shared/fi-local-search2/fi-local-search2.module';
import { FiItemsListModule } from '@fi-app/shared/fi-items-list/fi-items-list.module';
import { FiOnboardingActiveHelperService } from '@fi-app/fi-onboarding/fi-onboarding-active/fi-onboarding-active-helper.service';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiBindHtmlCompileModule } from '@fi-shared/fi-directives/bind-html-compile/bind-html-compile.module';
import { FiAttachmentsModule } from '@fi-shared/media-bank/fi-attachments/fi-attachments.module';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { FiFormatDateModule } from '@fi-shared/fi-format-date/fi-format-date.module';
import { FiEmptyListModule } from '@fi-app/shared/fi-empty-list/fi-empty-list.module';
import { FiLoadingModule } from '@fi-app/shared/fi-loading/fi-loading.module';
import { FiOnboardingProgressBarModule } from '../fi-onboarding-progress-bar/fi-onboarding-progress-bar.module';
import { FiOnboardingSynchronizedModule } from '@fi-app/fi-onboarding/fi-onboarding-synchronized/fi-onboarding-synchronized.module';
import { FiOnboardingActiveDataService } from '@fi-app/fi-onboarding/fi-onboarding-active/fi-onboarding-active-data.service';
import { FiExpandableTextDirectiveModule } from '@fi-app/shared/fi-expandable-text-directive/fi-expandable-text-directive.module';

@NgModule({
    imports: [
        CommonModule,
        FiLocalSearch2Module,
        FiItemsListModule,
        MatCardModule,
        MatButtonModule,
        MatIconModule,
        FiAppTextSharedModule,
        FiBindHtmlCompileModule,
        FiAttachmentsModule,
        MatProgressBarModule,
        FiFormatDateModule,
        FiEmptyListModule,
        FiLoadingModule,
        FiOnboardingProgressBarModule,
        FiOnboardingSynchronizedModule,
        FiExpandableTextDirectiveModule,
    ],
    declarations: [FiOnboardingActiveItemComponent, FiOnboardingActiveListComponent],
    providers: [FiOnboardingActiveService, FiOnboardingActiveHelperService, FiOnboardingActiveDataService],
})
export class FiOnboardingActiveModule {}
